import { getServiceUrl } from '../api.config';
import { ApiClientOptions } from '../types/api';
import ApiClient from '../utils/ApiClient';
import qs from '../utils/query';
import {
  isBoolean,
  isNotEmptyArray,
  isNotEmptyString,
  isPositiveInteger,
} from '../utils/validators';

export default class TransactionApi extends ApiClient {
  public constructor(options?: ApiClientOptions) {
    super(getServiceUrl('transaction'), options);
  }

  // --------------------------------------------------------------------------
  // Transactions
  public TransactionList(
    filter?: any,
    pagination?: any,
    useCache: boolean = false,
  ) {
    return this.List(filter, pagination, useCache);
  }

  public TransactionCount() {
    return this.Count();
  }

  public TransactionApply(id: string | number, action: any, filters: any = {}) {
    return this.Apply(id, action, filters);
  }

  public List(filter: any, pagination: any, useCache: boolean = false) {
    const q = '/transaction/v2/transactions';

    const params: any = {};
    if (isNotEmptyString(filter.entity_type)) {
      params.type = filter.entity_type;
    }
    if (isPositiveInteger(filter.entity_id)) {
      params.id = filter.entity_id;
    }
    if (isPositiveInteger(filter.role)) {
      params.role = filter.role;
    }
    if (isNotEmptyArray(filter.statuses)) {
      params.statuses = filter.statuses;
    }
    if (isNotEmptyArray(filter.event_types)) {
      params.event_types = filter.event_types.join();
    }
    if (isNotEmptyArray(filter.event_actions)) {
      params.event_actions = filter.event_actions.join();
    }
    if (isBoolean(filter.root)) {
      params.root = filter.root;
    }
    if (isNotEmptyArray(filter.sources)) {
      params.sources = filter.sources.join();
    }

    if (isPositiveInteger(pagination.limit)) {
      params.limit = pagination.limit;
    }
    if (isPositiveInteger(pagination.offset)) {
      params.offset = pagination.offset;
    }

    return this.get(q, qs.stringify(params, true), useCache);
  }

  public Count() {
    const query = '/transaction/v2/transactions/count';
    return this.get(query);
  }

  public Apply(id: string | number, action: any, filters: any = {}) {
    const query = `/transaction/v2/transactions/${id}/apply`;
    return this.post(query, { action, filters });
  }

  public Search(body: any) {
    const query = '/transaction/v3/transactions/search';
    return this.post(query, body);
  }

  public Index(ids: (string | number)[]) {
    const query = `/transaction/v2/transactions/index`;
    return this.post(query, { transaction_ids: ids });
  }
}
